<template>
  <div id="app">
    <Header></Header>
    <div class="main">
      <router-view name="slidebar"></router-view>
      <router-view name="main"></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*::before {
  margin: 0;
  padding: 0;
}

*::after {
  margin: 0;
  padding: 0;
}

#app {
  background-color: #e1e1e1;
}

.main {
  width: 90%;
  margin: 15px auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue